import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { TeamSetup } from '../../components/Onboarding/TeamSetup.component';
import { TeamPlanCode } from '../../lib/Paddle';

export const TeamSetupPage: React.FC = () => {
  const { planCode } = useParams<{ planCode: TeamPlanCode }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  if (!planCode) {
    navigate('/404');
    return;
  }

  // Set only by the general onboarding selector (HowDoYouWantToUse.component.tsx) -- the
  // marketing-driven signup flow (SignupTeams.component.tsx) reaches this same page without it
  // and still runs the real Paddle checkout (EZ-5083).
  const skipCheckout = searchParams.get('skipCheckout') === 'true';

  return <TeamSetup planCode={planCode} skipCheckout={skipCheckout} />;
};
